import AxiosCustom from "../../../common/components/apiConfig";

export const verify_offline_order_otp = (data) => {
  let config = { url: "update_request" };

  let _data = {
    table: "offlineorder",
    method_type: "verify_offline_order_otp",
    data: {
      ...data,
    },
  };

  return AxiosCustom(config, _data);
};
